import { RootState, Store } from '../../Store';
import { Action } from '../../Store/action';

export class StoreGateway {
    public constructor(private store?: Store) {}

    public setStore(store: Store): void {
        this.store = store;
    }

    public getState(): RootState {
        return this.getStore().getState();
    }

    public dispatch(action: Action): void {
        this.getStore().dispatch(action);
    }

    public getStore(): Store {
        if (typeof this.store !== 'undefined') {
            return this.store;
        }

        throw Error('Redux store not available');
    }
}
